export default __webpack_public_path__ + "static/22623-6290a8017dff546739c2e7a1e31200f5.jpg";